import './App.css';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import Homepage from './components/homepage/homepage';
import RegistrationForm from './components/User Register/register';
import RegisterSuccessful from './components/Registration Success/RegistrationSuccess';
import LoginForm from './components/Vendor Login/Login';
import Navbar from './components/Navbar/Navbar';
import VendorRegister from './components/VendorRegister/VendorRegister';
import { useState } from 'react';
import VendorDashboard from './components/Vendor Dashboard/VendorDashboard';
import ServiceDetails from './components/ServiceDetails/ServiceDetails';
import ServiceSuccess from './components/Service Success/ServiceSuccess';
import ProtectedRoute from './Auth/ProtectedRouting';
import UserLogin from './components/User Login/UserLogin';
import VendorDetails from './components/Vendor Details/VendorDetails';
import DisplayVendors from './components/Vendor Display/DisplayVendors';
import AdminDashboard from './components/Admin dashboard/AdminDashboard';
import AuthorizeVendors from './components/Admin dashboard/Authorize Vendors/AuthorizeVendors';
import UserTask from './components/User Tasks/UserTask';
import Blogs from './components/Blogs/Blogs';
import UserPlans from './components/UserPlans/UserPlans';
import Profile from './components/Profile/profile';
import ReviewCarousel from './components/Reviews/Reviews';
import CreateRealWedding from './components/Real_Weddings/Create_real_wedding/CreateRealWedding';
import DisplayRealWeddings from './components/Real_Weddings/display_real_weddings/DisplayRealWeddings';
import RealWeddings from './components/Admin dashboard/Real-weddings/RealWeddings';
import ForgotPassword from './components/Forgot password/ForgotPassword';
import ResetPassword from './components/Forgot password/ResetPassword';
import Aboutus from './components/AboutUs/AboutUs';
import ExpenseTracker from './components/Expense Tracker/ExpenseTracker';
import CartScreen from './components/User Cart/UserCart';
import Wishlist from './components/Wishlist/wishlist';
import Vendors from './components/vendors/vendors';
import DynamicBreadcrumbs from './components/dynamic_breadcumb/dynamic_breadcrumb';
import DisplayVendor from './components/display_vendors/display_vendors';
import TermsConditions from './components/terms_conditions/terms_conditions';
import PrivacyPolicy from './components/privacy_policy/privacy_policy';
import VendorServices from './components/Vendor Dashboard/Dashboard Services/VendorServices';
import ServiceForm from './components/Create Service/ServiceForm';
import VendorChatApp from './components/Vendor Dashboard/Dashboard ChatApp/VendorChatApp';
import ReviewModal from './ui_components/review_modal/ReviewModal';
import Footer from './components/footer/footer';
import EditService from './components/Vendor Dashboard/Dashboard Services/edit_vendor_service/edit_service';
import ReadBlog from './components/Blogs/read-blog/read-blog';
import VendorTermsConditions from './components/vendor_terms_conditions/vendor_terms_conditions';

function App() {
  const [token, setToken] = useState(() => {
    const storedToken = localStorage.getItem("token");
    return storedToken || null;
  });
  const [userRole, setUserRole] = useState(() => {
    const storedRole = localStorage.getItem("role");
    return storedRole || null;
  });

  const [showReviewPopup, setShowReviewPopup] = useState(false);

  const handleReviewSubmit = (formData) => {
    console.log("Review Submitted:", formData);
  };
  return (
    <>
      <BrowserRouter>
        <Navbar token={token} userRole={userRole} setToken={setToken} setUserRole={setUserRole} onWriteReviewClick={() => setShowReviewPopup(true)} />
        <Routes>
          <Route path='/' element={<Homepage />} />
          <Route path='/home' element={<Navigate to="/" />} />
          <Route path='/register-success' element={<RegisterSuccessful />} />
          <Route path='*' element={<Navigate to="/" />} />
          <Route path='/vendor-list' element={<DisplayVendors />} />
          <Route path='/plans' element={<UserPlans />} />
          <Route path='/reviews' element={<ReviewCarousel />} />
          <Route path='/profile' element={<Profile />} />
          <Route path='/real-weddings' element={<DisplayRealWeddings />} />
          <Route path='/about-us' element={<Aboutus />} />
          <Route path='/vendors/:category' element={<DisplayVendor />} />
          <Route path='/blogs' element={<Blogs />} />
          <Route path='/terms-conditions' element={<TermsConditions />} />
          <Route path='/privacy-policy' element={<PrivacyPolicy />} />
          <Route path='/vendor/:vendor_id' element={<VendorDetails />} />
          <Route path="/vendors/:category/:location" element={<DisplayVendors />} />
          <Route path='/vendors' element={<Vendors />} />
          <Route path='/read-blog/:blogId' element={ <ReadBlog/> }/>
          <Route path='/vendor/terms-conditions' element={<VendorTermsConditions />} />

          {/* Unauthorized Routes */}
          {!token &&
            <>
              <Route path='/vendor-login' element={<LoginForm />} />
              <Route path='/user-register' element={<RegistrationForm />} />
              <Route path='/vendor-register' element={<VendorRegister />} />
              <Route path='/user-login' element={<UserLogin />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path='/vendors' element={<Vendors />} />
              <Route path='/vendor/:vendor_id' element={<VendorDetails />} />
              <Route path='/work/vendor/:vendor_id' element={<VendorDetails />} />
            </>

          }

          {/* Protected Routes */}
          <Route element={<ProtectedRoute />}>
            {userRole === "VENDOR" ?
              (
                // render this routes if Role is Vendor
                <>
                  <Route path='/' element={<Homepage />} />
                  <Route path='/vendor-login' element={<Navigate to="/" />} />
                  <Route path='/vendor-register' element={<Navigate to="/" />} />
                  <Route path='/service-details/:service_id' element={<ServiceDetails />} />
                  <Route path='/service-create-success' element={<ServiceSuccess />} />
                  <Route path='/vendor-dashboard' element={<VendorDashboard />} />
                  <Route path='/vendor/:vendor_id/service/:service_id/edit' element={<EditService />} />
                  <Route path='/vendor/:vendor_id/services' element={<VendorServices />} />
                  <Route path='/vendor/:vendor_id/create-service' element={<ServiceForm />} />
                  <Route path='/vendor/:vendor_id/chats' element={<VendorChatApp />} />
                  <Route path='/vendor/:vendor_id/analytics' element={<div> Analyatics </div>} />
                  <Route path='/tasks' element={<Navigate to="/" />} />
                  <Route path='/blogs' element={<Blogs />} />
                </>
              )
              : userRole === "USER" ? (
                //render this routes if Roles is User
                <>
                  <Route path='/' element={<Homepage />} />
                  <Route path='/vendor-login' element={<Navigate to="/" />} />
                  <Route path='/vendor-register' element={<Navigate to="/" />} />
                  <Route path='/vendor-dashboard' element={<Navigate to="/" />} />
                  <Route path='/service-details/:service_id' element={<ServiceDetails />} />
                  <Route path='/service-create-success' element={<Navigate to="/" />} />
                  <Route path='/authorize-vendors' element={<AuthorizeVendors />} />
                  <Route path='/tasks' element={<UserTask />} />
                  <Route path='/blogs' element={<Blogs />} />
                  <Route path='/expense-tracker' element={<ExpenseTracker />} />
                  <Route path='/cart' element={<CartScreen />} />
                  <Route path='/wishlist' element={<Wishlist />} />
                  <Route path='/vendors' element={<Vendors />} />

                </>
              )
                : userRole === "ADMIN" ? (
                  <>
                    <Route path='/admin-dashboard' element={<AdminDashboard />} />
                    <Route path='/authorize-vendors' element={<AuthorizeVendors />} />
                    <Route path='/service-details' element={<ServiceDetails />} />
                    <Route path='/blogs' element={<Blogs />} />
                    <Route path='/create-real-wedding' element={<CreateRealWedding />} />
                    <Route path='/manage-real-weddings' element={<RealWeddings />} />
                  </>
                )
                  :
                  (<Route path='/vendor-login' element={<Navigate to="/" />} />)}
          </Route>
        </Routes>
        <Footer />
      </BrowserRouter>
      <ReviewModal
        show={showReviewPopup}
        onClose={() => setShowReviewPopup(false)}
        onSubmit={handleReviewSubmit}
      />
    </>
  );
}

export default App;
